import { useTranslation } from 'react-i18next'
import { dateFormatter } from '../../../utils'
import Card from './Card/Card'
import "./style.css"

const UserInfoSection = ({ data }) => {
    const { t } = useTranslation()
    return (
        <div className="user-info-container">
            <div className="user-request-info">
                <div className="">
                    <Card name="patientName" value={data.patientName} />
                    <Card name="patientPhoneNumber" value={data.patientPhoneNumber} />
                    {data.secondPhoneNumber && <Card name="secondPhoneNumber" value={data.secondPhoneNumber} />}
                    <Card name="serialNumber" value={data.serialNumber} />
                    {data?.patientFileNumber && <Card name="patientFileNumber" value={data?.patientFileNumber} />}
                </div>
                <div className="">
                    {!data.isFakeDecision &&
                        <>
                            <Card name="decisionsNumber" value={data.decisionsNumber} />
                            <Card name="decisionsEndDate" value={data.decisionsEndDate?.split("T")[0]} />
                        </>
                    }
                    <Card name="monthsCoverdCount" value={`${data.coveredMonths} ${t("month")}`} />
                    <Card name="requestCreatedDate" value={dateFormatter(data?.requestCreatedDate, "ar", { month: "long", year: "numeric" })} />
                </div>
            </div>
            <Card name="patientAddress" value={data.patientAddress} />
            <Card name="specialAddress" value={data?.addressLandMark} />
            <div className="d-flex justify-content-between px-3">
                <Card name="nationalId" value={null} />
                <Card name="signatureRequest" value={null} className="signiture-print" />
            </div>
        </div>
    )
}

export default UserInfoSection